// extracted by mini-css-extract-plugin
export default {"icon":"notifications_icon__svdkb","title":"notifications_title__qeyid","date":"notifications_date__T+obd"};